import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { UserPlanProvider } from "./context/UserPlanContext";
import LandingPage from "./pages/LandingPage";
import CortexRuntime from "./pages/CortexRuntime";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import MyLibrary from "./pages/MyLibrary";
import ExploreAgents from "./pages/ExploreAgents";
import BillingSettings from "./pages/BillingSettings";
import ErrorBoundary from "./ErrorBoundary";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="bg-charcoal min-h-screen text-offwhite font-inter">
      <ErrorBoundary>
        <Router>
          <AuthProvider>
            <UserPlanProvider>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/runtime" element={<CortexRuntime />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/library" element={<MyLibrary />} />
                <Route path="/explore" element={<ExploreAgents />} />
                <Route path="/billing" element={<BillingSettings />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
              </Routes>
            </UserPlanProvider>
          </AuthProvider>
        </Router>
      </ErrorBoundary>
    </div>
  );
}

export default App;
